import ProductList from './components/listProduts';

export default {
    icon: '',
    url: 'produtos',
    name: 'Produtos',
    routes: [
        {
            path: '/produtos',
            name: 'products',
            component: ProductList
        },        
    ]
}